const items = [
  { icon: 'ri-check-double-line', text: '30-80% besparing op inkoop', href: null },
  { icon: 'ri-mail-line', text: 'Info@directuitchina.nl', href: 'mailto:Info@directuitchina.nl' },
  { icon: 'ri-phone-line', text: '+31 6 24 35 91 62', href: 'tel:+31624359162' },
  { icon: 'ri-instagram-line', text: '@directuitchina', href: 'https://www.instagram.com/directuitchina/' },
  { icon: 'ri-ship-line', text: 'DDP levering – all-in', href: null },
  { icon: 'ri-time-line', text: 'Reactie binnen 24 uur', href: null },
];

interface TickerItemProps { icon: string; text: string; href: string | null; }

const TickerItem = ({ icon, text, href }: TickerItemProps) => {
  const content = (
    <span className="inline-flex items-center gap-3 whitespace-nowrap">
      <span className="w-3.5 h-3.5 flex items-center justify-center flex-shrink-0">
        <i className={`${icon} text-[#3B9EE8] text-xs`} />
      </span>
      <span className="text-white/70 text-xs">{text}</span>
      <span className="text-white/12 ml-8">·</span>
    </span>
  );

  if (href) {
    return (
      <a href={href} target={href.startsWith('http') ? '_blank' : undefined} rel={href.startsWith('http') ? 'nofollow noreferrer' : undefined} className="inline-flex items-center px-8 hover:opacity-100 transition-opacity cursor-pointer">
        {content}
      </a>
    );
  }
  return <span className="inline-flex items-center px-8">{content}</span>;
};

export default function AnnouncementBar() {
  const repeated = [...items, ...items, ...items];
  return (
    <div className="h-8 bg-[#050E1A] border-b border-white/6 overflow-hidden flex items-center">
      <div className="animate-ticker flex">
        {repeated.map((item, i) => (
          <TickerItem key={`${item.text}-${i}`} icon={item.icon} text={item.text} href={item.href} />
        ))}
      </div>
    </div>
  );
}
